/**
 * Textos del inicio (tono cercano, alineado con requirements/hikarai.md).
 * Ver también requirements/CONTENT-AUTHORING.md.
 */
export const homeCopy = {
  heroBadge: "Medellín · máximo 10 por tipo de producto",
  heroTitleHtml: 'Diseños de anime que <span class="home-hero__title-glow">sí te gustarían tener</span>',
  heroLead:
    "Hacemos tazas, ropa, posters y más con series que vemos en casa. Cada diseño tiene un tope: pocas unidades para que no sea lo de siempre.",
  heroPrimaryCta: { label: "Ver colecciones", href: "/colecciones.html" },
  heroSecondaryCta: { label: "Stock permanente", href: "/catalogo.html" },
  valuePropTitle: "Hecho por fans, para fans",
  valuePropLead:
    "Nos cansamos de ver el mismo personaje mal dibujado en todas las vitrinas. Queremos piezas bonitas, bien hechas, con las series que hoy nos emocionan.",
  formatsTitle: "De todo un poco, bien hecho",
  formatsSub:
    "Tazas en cerámica, vidrio y peltre, mouse pads, portavasos, termos y caramañolas, posters en aluminio, rompecabezas, llaveros, camisetas, buzos y cajas sorpresa.",
} as const;
